/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';
import { Directive } from '@angular/core';

@Directive({
    selector: '[appNameValidator]',
    providers: [{ provide: NG_VALIDATORS, useExisting: NameValidationDirective, multi: true }]
})

export class NameValidationDirective implements Validator {
    public validate(control: AbstractControl): { [key: string]: any } | null {
        return nameValidation(control);
    }
}

/**
 * Name validation.
 * @param control
 * @returns {any}
 */
export function nameValidation(control: any): any {
    if (!control?.value) {
        return null;
    }

    if ((/^\s|\s\s/gm).test(control?.value)) {
        return { 'nameValidation': 'invalid_name_start_space' };
    }

    if (!(/^[A-Za-z0-9,.'(){}[\] _-]*$/g).test(control?.value)) {
        return { 'nameValidation': 'invalid_name_characters' };
    }

    if (control?.value?.length < 2) {
        return { 'nameValidation': 'invalid_name_length_short' };
    }

    if (control?.value?.length > 254) {
        return { 'nameValidation': 'invalid_name_length' };
    }
}
